import React from 'react';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    pill: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        backgroundColor: '#E7EFFE',
        borderRadius: '999px',
        color: '#062D7A',
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '22px',
        padding: '8px 16px',
        textAlign: 'center',
        width: 'fit-content'
    },
    pillMuted: {
        backgroundColor: '#E8EAF4',
        color: '#A6A6BF'
    }
}));

type PillProps = {
    muted?: boolean;
    text: string;
};

const Pill: React.FC<PillProps> = ({
    muted = false,
    text
}) => {
    const classes = useStyles();

    return (
        <span className={`${classes.pill} ${muted ? classes.pillMuted : ''}`}>
            {text}
        </span>
    );
};

export default Pill;
